import { createApi, } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../../utils/general";

export const fundApiSlice = createApi({
  reducerPath: "fundApi",
  tagTypes: ["Fund"],
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    prepareCrowdFunding: builder.mutation({
      query: ({ body, id }) => ({
        url: `/fund/crowd-funding/prepare/${id}`,
        method: "POST",
        body,
      }),

      invalidatesTags: [
        {
          type: "Fund",
          id: "LIST",
        },
      ],
    }),
    announceMintCrowdFunding: builder.mutation({
      query: ({ body, id }) => ({
        url: `/fund/crowd-funding/announce-mint/${id}`,
        method: "POST",
        body,
      }),

      invalidatesTags: [
        {
          type: "Fund",
          id: "LIST",
        },
      ],
      //   providesTags: (result, error, arg) => [{ type: "Fund", id: arg?.id }],
    }),
    editFund: builder.mutation({
      query: ({ body, id }) => ({
        url: `/funds/edit/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [
        {
          type: "Fund",
          id: "LIST",
        },
      ],
    }),

    resumeFundProcess: builder.mutation({
      query: ({ id }) => ({
        url: `/fund/crowd-funding/resume/${id}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useAnnounceMintCrowdFundingMutation,
  usePrepareCrowdFundingMutation,
  useResumeFundProcessMutation
} = fundApiSlice;
